<p-tabs [value]="activeIndex" class="submenu-tabs">
  <p-tablist>
    @for (item of items(); track item; let i = $index) {
      <p-tab
        [value]="i"
        [routerLink]="[item.routerLink]"
        routerLinkActive
        [routerLinkActiveOptions]="{ exact: true }"
        (isActiveChange)="onActiveChange(i, $event)"
        [ngClass]="item.buttonStyleClass"
        >
        <div class="d-flex align-items-center gap-2">
          @if (item.icon) {
            <i
              [class]="item.icon"
            ></i>
          }
          <span>{{item.label}}</span>
        </div>
      </p-tab>
    }
  </p-tablist>
</p-tabs>